<h2 mat-dialog-title translate="CALLS.SHARE_DIALOG.TITLE" [translateParams]="{ title: call.name }"></h2>
<mat-dialog-content>
  <div class="content-container">
    <h4 translate="CALLS.SHARE_DIALOG.CURRENT_SHARES"></h4>
    <mat-divider></mat-divider>
    <div class="shared-people">
      @for (user of call.users; track user.id) {
        <div class="item">
          <div class="left">
            <div class="user">{{ user | userName }} ({{ user.email }})</div>
          </div>
          <div class="right">
            <div class="participant">
              <mat-chip>{{ 'COMMON.CALL_OWNER' | translate }}</mat-chip>
            </div>
          </div>
        </div>
      }

      @for (share of call.shares; track share.sharedUserId) {
        <div class="shared-person item">
          <div class="left">
            <div class="user">
              {{ share.sharedUser | userName }} ({{ share.sharedUser.email }})
              @if (canEdit) {
                <mat-icon class="clickable" color="warn" (click)="removeShare(share.sharedUser)" [matTooltip]="'COMMON.REMOVE' | translate">delete</mat-icon>
              }
            </div>
          </div>
          <div class="right">
            @if (canEdit) {
              <div class="role">
                <mat-form-field subscriptSizing="dynamic">
                  <mat-label translate="CALLS.SHARE_DIALOG.ACCESS_LEVEL"></mat-label>
                  <mat-select required [value]="share.level" (selectionChange)="updateShareLevel(share.sharedUserId, $event.value)">
                    <mat-option value="VIEWER">{{ 'CALLS.SHARE_DIALOG.LEVELS.VIEWER' | translate }}</mat-option>
                    <mat-option value="COMMENTER">{{ 'CALLS.SHARE_DIALOG.LEVELS.COMMENTER' | translate }}</mat-option>
                    <mat-option value="EDITOR">{{ 'CALLS.SHARE_DIALOG.LEVELS.EDITOR' | translate }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            } @else {
              <div class="participant">
                <mat-chip>{{ 'CALLS.SHARE_DIALOG.LEVELS.' + share.level | translate }}</mat-chip>
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div class="add-user-container">
      @if (canEdit) {
        @if (showShareForm) {
          <mat-divider></mat-divider>
          <div class="item">
            <mat-form-field>
              @if (call.allowThirdPartySharing) {
                <mat-label translate="CALLS.SHARE_DIALOG.USER_EMAIL_INPUT"></mat-label>
              } @else {
                <mat-label translate="CALLS.SHARE_DIALOG.USER_INPUT"></mat-label>
              }
              <input
                type="text"
                matInput
                required
                name="share-target"
                autocomplete="off"
                [(ngModel)]="email"
                (input)="filterOrganizationUsers(shareTarget.value.toLowerCase()); userToShareTo = null"
                (focus)="filterOrganizationUsers(shareTarget.value.toLowerCase())"
                [matAutocomplete]="auto"
                #shareTarget
              />
              <mat-autocomplete [displayWith]="displayUserOnAutocomplete" (optionSelected)="userToShareTo = $event.option.value" #auto="matAutocomplete">
                @for (user of filteredOrganizationUsers; track user.id) {
                  <mat-option [value]="user">{{ user | userName }} ({{ user.email }})</mat-option>
                }
              </mat-autocomplete>
              @if (call.allowThirdPartySharing) {
                <mat-hint translate="CALLS.SHARE_DIALOG.USER_EMAIL_INPUT_DISCLAIMER"></mat-hint>
              }
            </mat-form-field>
            @if (displayNameInput) {
              <mat-form-field>
                <mat-label translate="COMMON.NAME"></mat-label>
                <input matInput required name="firstName" [(ngModel)]="firstName" />
              </mat-form-field>
              <mat-form-field>
                <mat-label translate="COMMON.LAST_NAME"></mat-label>
                <input matInput required name="lastName" [(ngModel)]="lastName" />
              </mat-form-field>
            } @else if (userToShareTo !== null || emailMatchesExistingUser) {
              <mat-checkbox
                labelPosition="after"
                class="notifyByEmailCheckBox"
                [(ngModel)]="notifyByEmail"
                translate="CALLS.SHARE_DIALOG.NOTIFY_BY_EMAIL"
              ></mat-checkbox>
            }
            <mat-form-field>
              <mat-label translate="CALLS.SHARE_DIALOG.ACCESS_LEVEL"></mat-label>
              <mat-select required [(ngModel)]="level">
                <mat-option value="VIEWER">{{ 'CALLS.SHARE_DIALOG.LEVELS.VIEWER' | translate }}</mat-option>
                <mat-option value="COMMENTER">{{ 'CALLS.SHARE_DIALOG.LEVELS.COMMENTER' | translate }}</mat-option>
                <mat-option value="EDITOR">{{ 'CALLS.SHARE_DIALOG.LEVELS.EDITOR' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="item">
            <button translate="COMMON.CANCEL" mat-raised-button (click)="showShareForm = false"></button>
            @if (loading) {
              <app-spinner class="loader" size="medium"></app-spinner>
            } @else {
              <button translate="COMMON.SHARE" mat-raised-button color="primary" (click)="shareCall()" [disabled]="!isValidInput()"></button>
            }
          </div>
        } @else {
          <div class="item">
            <button translate="COMMON.ADD" mat-raised-button color="primary" (click)="showShareForm = true"></button>
          </div>
        }
      }
    </div>

    <mat-divider></mat-divider>
    <div class="public-access-container">
      <h4 translate="CALLS.SHARE_DIALOG.PUBLIC_ACCESS"></h4>
      <div class="item">
        <div class="left">
          @if (canEdit) {
            <mat-form-field>
              <mat-label translate="CALLS.SHARE_DIALOG.AVAILABILITY"></mat-label>
              <mat-select required [ngModel]="call.publicLinkAvailability" (selectionChange)="updatePublicLinkAvailability($event.value)" [panelWidth]="400">
                <mat-option value="PARTICIPANTS_AND_PEOPLE_WITH_ACCESS_ONLY">
                  <b>{{ 'CALLS.SHARE_DIALOG.PUBLIC_ACCESS_LEVELS.PARTICIPANTS_AND_PEOPLE_WITH_ACCESS_ONLY.TITLE' | translate }}</b>
                  - <span class="description" translate="CALLS.SHARE_DIALOG.PUBLIC_ACCESS_LEVELS.PARTICIPANTS_AND_PEOPLE_WITH_ACCESS_ONLY.DESCRIPTION"></span>
                </mat-option>
                <mat-option value="SAME_ORGANIZATION">
                  <b>{{ 'CALLS.SHARE_DIALOG.PUBLIC_ACCESS_LEVELS.SAME_ORGANIZATION.TITLE' | translate }}</b> -
                  <span class="description" translate="CALLS.SHARE_DIALOG.PUBLIC_ACCESS_LEVELS.SAME_ORGANIZATION.DESCRIPTION"></span>
                </mat-option>
                <mat-option value="ANYONE_WITH_ACCOUNT" [disabled]="!call.allowThirdPartySharing">
                  <b>{{ 'CALLS.SHARE_DIALOG.PUBLIC_ACCESS_LEVELS.ANYONE_WITH_ACCOUNT.TITLE' | translate }}</b> -
                  <span class="description" translate="CALLS.SHARE_DIALOG.PUBLIC_ACCESS_LEVELS.ANYONE_WITH_ACCOUNT.DESCRIPTION"></span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          } @else {
            <div class="title">
              {{ 'CALLS.SHARE_DIALOG.PUBLIC_ACCESS_LEVELS.' + call.publicLinkAvailability + '.TITLE' | translate }}
            </div>
            <div class="description">
              {{ 'CALLS.SHARE_DIALOG.PUBLIC_ACCESS_LEVELS.' + call.publicLinkAvailability + '.DESCRIPTION' | translate }}
            </div>
          }
        </div>
        <div class="right">
          @if (canEdit) {
            <mat-form-field>
              <mat-label translate="CALLS.SHARE_DIALOG.ACCESS_LEVEL"></mat-label>
              <mat-select required [value]="call.publicLinkAccessLevel" (selectionChange)="updatePublicShareLevel($event.value)">
                <mat-option value="VIEWER">{{ 'CALLS.SHARE_DIALOG.LEVELS.VIEWER' | translate }}</mat-option>
                <mat-option value="COMMENTER">{{ 'CALLS.SHARE_DIALOG.LEVELS.COMMENTER' | translate }}</mat-option>
                <mat-option value="EDITOR">{{ 'CALLS.SHARE_DIALOG.LEVELS.EDITOR' | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          } @else {
            {{ 'CALLS.SHARE_DIALOG.LEVELS.' + call.publicLinkAccessLevel | translate }}
          }
        </div>
      </div>
    </div>
    <div class="copy-link-container">
      <button mat-raised-button [cdkCopyToClipboard]="publicLink">
        <mat-icon>link</mat-icon>
        {{ 'CALLS.SHARE_DIALOG.COPY_LINK' | translate }}
      </button>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="null" cdkFocusInitial translate="COMMON.DONE" color="primary"></button>
</mat-dialog-actions>
